import * as IoC from 'inversify';
import { StudentInfoDataStoreSymbol, StudentInfoDataStore } from '../common/student-info-data-store';
import { studentInfoCommonTrackingModule } from '../common/di'
import { Scorm2004StudentInfoDataStore } from './scorm2004-student-info-data-store';

const studentInfoScorm2004TrackingModule = new IoC.ContainerModule((bind) => {
  bind<StudentInfoDataStore>(StudentInfoDataStoreSymbol).to(Scorm2004StudentInfoDataStore)
})

export const studentInfoScorm2004TrackingModules = [
  studentInfoCommonTrackingModule,
  studentInfoScorm2004TrackingModule,
]
